import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { MainStoreState } from 'store/main/MainStoreState';

export const useMainSelector: TypedUseSelectorHook<MainStoreState> =
  useSelector;
